import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { of, Observable, switchMap } from 'rxjs';
import { navigateToHome } from '../../../../../core/resolver/shared/functions/navigate-to-home.function';
import { ApplicationService } from '../../../shared/services/application/application.service';
import { RouteConstants } from '../../../../../core/constants/routes';

export const GoPageApplicationHandedOverResolver = (
    route: ActivatedRouteSnapshot,
): Observable<boolean> => {
    const applicationService = inject(ApplicationService);

    const router = inject(Router);

    const applicationId = route.paramMap.get('id');

    if (!applicationId) {
        return navigateToHome(router);
    }

    return applicationService.getApplicationState(applicationId).pipe(
        switchMap((state) => {
            if (state.handoverToEwa) {
                return navigateToCompletePage(router, applicationId);
            }

            return of(true);
        }),
    );
};

const navigateToCompletePage = (
    router: Router,
    applicationId: string,
): Observable<boolean> => {
    router.navigate([
        RouteConstants.Go.getFullRouteWithApplicationId(
            'complete',
            applicationId,
        ),
    ]);

    return of(false);
};
